import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { TextContainer } from './fdr-geo-information-section.styles';

export const GeoLongTextWrapper = styled.div(({ theme: { colors } }) =>
  sx2CssThemeFn({
    backgroundColor: colors.lightGreyThird,
  })
);

export const GeoLongTextContent = styled(TextContainer)(
  sx2CssThemeFn({
    py: ['50px', 9],
    h2: {
      margin: '0 auto',
      width: ['100%', '818px'],
      textAlign: 'center',
      fontSize: [7, '46px'],
      pt: 0,
      mb: ['32px', '60px'],
    },
    a: {
      textDecoration: 'underline',
      '&:hover, &:focus, &:active': {
        color: 'redHover',
        textDecoration: 'underline',
      }
    },
  })
);

export const GeoLongTextItemOneColumn = styled.div(
  sx2CssThemeFn({
    width: ['initial', '818px'],
    margin: 'auto',
  })
);

export const GeoLongTextItemTwoColumns = styled.div(
  sx2CssThemeFn({
    display: ['initial', 'grid !important'],
    marginTop: [0, '44px'],
    gridTemplateColumns: '1fr 800px',
    gap: '0 80px',
    h3: {
      gridColumn: ['initial', 1],
      fontSize: [5, '46px'],
    },
    p: {
      gridColumn: ['initial', 2],
    },
    '&:first-child': {
      marginTop: 0,
    },
  })
);
